import { effect, Injectable, inject } from "@angular/core";
import { ThemeService } from "@tylertech/core-module";
import { getLoggerFor } from "@tylertech/logging";
import { Chart, Color } from "chart.js";

@Injectable()
export class ChartService
{
    private readonly $themeService = inject(ThemeService);

    private readonly log = getLoggerFor("ChartService");

    constructor()
    {
        Chart.defaults.plugins.tooltip.borderWidth = 1;

        effect(() =>
        {
            const isDarkTheme = this.$themeService.isDarkTheme();
            this.log.debug("$themeService.isDarkTheme -> effect", { isDarkTheme });

            Chart.defaults.color = this.$themeService.chartStyleColors().color;
            Chart.defaults.borderColor = this.$themeService.chartStyleColors().borderColor;

            if (Chart.defaults.plugins.legend?.labels)
            {
                Chart.defaults.plugins.legend.labels.color = this.$themeService.chartStyleColors().legendLabelColor;
            }

            if (Chart.defaults.plugins.tooltip)
            {
                Chart.defaults.plugins.tooltip.bodyColor = this.$themeService.chartStyleColors().tooltipBodyColor;
                Chart.defaults.plugins.tooltip.backgroundColor = this.$themeService.chartStyleColors().tooltipBackgroundColor;
                Chart.defaults.plugins.tooltip.borderColor = this.$themeService.chartStyleColors().tooltipBorderColor;
                Chart.defaults.plugins.tooltip.titleColor = this.$themeService.chartStyleColors().tooltipTitleColor;
            }

            if (Chart.defaults.plugins.title)
            {
                Chart.defaults.plugins.title.color = this.$themeService.chartStyleColors().titleColor;
            }
        });
    }

    getColors(count: number = 0): ReadonlyArray<Color>
    {
        const chartColors = this.$themeService.colorSeries();

        const gcLength = chartColors.length;
        if (count !== 0 && count <= gcLength)
        {
            return chartColors.slice(0, count);
        }

        return chartColors;
    }

    getTrendLineColor(): string
    {
        return this.$themeService.chartStyleColors().trendLineColor;
    }
}
